import Slider from 'rc-slider';
import { memo } from 'react';
import styles from '../../styles/HtsAudioPlayer.module.scss';
import { HtslIcon } from '../HtsIcon';
import { HtsTypography } from '../HtsTypography';

import 'rc-slider/assets/index.css';
import '../../styles/HtsSlider.scss';

interface AudioPlayerUIProps {
  isPlaying: boolean;
  currentTime: number;
  duration: number;
  showSongTitle?: boolean;
  fullWidth?: boolean;
  songTitle?: string;
  showDuration?: boolean;
  titleTypographyProps?: React.ComponentProps<typeof HtsTypography>;
  playButtonClassName?: string;
  sliderContentContainerClassName?: string;
  containerClassName?: string;
  rightContent?: React.ReactNode;
  togglePlay: () => void;
  changeCurrentTime: (value: number | number[]) => void;
}

const formatTime = (timeInSeconds: number) => {
  const minutes = Math.round(timeInSeconds / 60);
  const seconds = Math.round(timeInSeconds % 60)
    .toString()
    .padStart(2, '0');

  return `${minutes}:${seconds}`;
};

export const AudioPlayerUI = memo(
  ({
    isPlaying,
    currentTime,
    duration,
    showSongTitle,
    songTitle,
    titleTypographyProps,
    showDuration,
    sliderContentContainerClassName = '',
    containerClassName = '',
    playButtonClassName = '',
    fullWidth = false,
    rightContent,
    togglePlay,
    changeCurrentTime,
  }: AudioPlayerUIProps) => {
    return (
      <div
        className={`${styles.container} ${containerClassName}`}
        style={{ width: fullWidth ? '100%' : undefined }}
      >
        <button className={`${styles.playStopButton} ${playButtonClassName}`} onClick={togglePlay}>
          <HtslIcon icon={isPlaying ? 'pause' : 'play'} color="primaryDark" />
        </button>

        <div className={`${styles.sliderContentContainer} ${sliderContentContainerClassName}`}>
          {showSongTitle && (
            <div className={styles.songTitleContainer}>
              <HtsTypography
                variant="caption"
                {...titleTypographyProps}
                className={styles.songTitle}
              >
                {songTitle}
              </HtsTypography>
            </div>
          )}

          <div className={styles.durationContainer}>
            {showDuration && (
              <HtsTypography variant="caption" className={styles.activeDurationText}>
                {formatTime(currentTime)}
              </HtsTypography>
            )}

            <Slider
              value={currentTime}
              min={0}
              max={duration}
              step={1}
              onChange={changeCurrentTime}
            />

            {showDuration && (
              <HtsTypography variant="caption" className={styles.totalDurationText}>
                {formatTime(duration)}
              </HtsTypography>
            )}
          </div>
        </div>

        {rightContent}
      </div>
    );
  }
);
